import { Equal, Plus, X, Divide01, Minus } from "untitledui-js-base";

type Symbols = "=" | "+" | "-" | "X" | "/";

const Symbols = ({ symbol }: { symbol: Symbols }) => {
  switch (symbol) {
    case "=":
      return <Equal size="14" />;
    case "+":
      return <Plus size="14" />;
    case "-":
      return <Minus size="14" />;
    case "X":
      return <X size="14" />;

    case "/":
      return <Divide01 size="14" />;
    default:
      return null;
  }
};

export const RoundedMathSymbol = ({ symbol }: { symbol: Symbols }) => {
  return (
    <div className="shrink-0 size-8 rounded-full border border-alpha-100 flex justify-center items-center">
      <Symbols symbol={symbol} />
    </div>
  );
};
